import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { Collapse } from "@mui/material";

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomSelect from "../../../common/CustomSelect";
import PromptProperties from "./PromptProperties";

import { allFieldsHaveValue, delay } from "../../../utils";
import { TestPromptV2, UpdatePromptV2, } from "../../../redux/prompt/actions";

import usePrompt from "../../../hooks/usePrompt";

function NewPromptDetails(props) {
    const { arrangePromptValues } = usePrompt();

    const outputRef = useRef(null);
    const [promptOutput, setPromptOutput] = useState(null);
    const [openSystemPrompt, setOpenSystemPrompt] = useState(false);
    const [temporaryPrompt, setTemporaryPrompt] = useState("");
    const [promptDetails, setPromptDetails] = useState({
        name: "",
        text: "",
        type: "user",
        class: "raw",
        systemPrompt: null,
        newSystemPrompt: null,
        properties: [
            {
                name: "Full Name",
                key: "fullName",
                type: "text",
                note: "user's full name",
                value: "",
            },
            {
                name: "Age",
                key: "age",
                type: "text",
                note: "user's age",
                value: "",
            }
        ],
    });

    useEffect(() => {
        if (props?.promptValues) {
            setPromptDetails({
                ...props?.promptValues,
                properties: !props?.promptValues?.props ? createProps(props?.promptValues?.text) : props?.promptValues?.properties,
            });
        }
    }, [props?.promptValues])

    const extractDynamicFields = (template) => {
        const regex = /{{(.*?)}}/g;
        const fields = [];
        let match;
        while ((match = regex.exec(template)) !== null) {
            fields.push(match[1]);
        }
        return fields;
    };

    const createProps = (text) => {
        let fields = extractDynamicFields(text);

        return fields.map((field) => {
            return {
                name: field,
                key: field,
                type: "text",
                note: "",
                value: "",
            }
        }) || [];

    };

    const handleChange = (e) => {
        setPromptDetails({
            ...promptDetails,
            [e.target.name]: e.target.value,
        });
    }

    const handleSystemPromptChange = (e, key) => {
        if (promptDetails?.systemPrompt == "new") {
            setPromptDetails({
                ...promptDetails,
                newSystemPrompt: {
                    ...promptDetails?.newSystemPrompt,
                    [key]: e.target.value
                },
            });
        } else {
            setPromptDetails({
                ...promptDetails,
                updatedSystemPrompt: {
                    ...promptDetails?.newSystemPrompt,
                    [key]: e.target.value
                },
            });
        }

    }

    const systemPromptsOptions = props?.Prompt?.systemPrompts?.map((prompt) => {
        return {
            label: prompt.name,
            value: prompt.id,
        }
    });


    const selectedSystemPrompt = props?.Prompt?.systemPrompts?.find((prompt) => prompt.id == promptDetails?.systemPrompt);
    const isSubmitActive = !allFieldsHaveValue({
        name: promptDetails?.name,
        text: temporaryPrompt || promptDetails?.text,
        type: promptDetails?.type,
        class: promptDetails?.class,
    });
    const promptPreview = promptDetails?.properties ? arrangePromptValues(temporaryPrompt || promptDetails?.text, promptDetails?.properties) : "";


    return (
        <>
            <div id="prompt-details" className="pd-add">
                <div className="pd-left">
                    <PromptProperties promptDetails={promptDetails} setPromptDetails={setPromptDetails} handleChange={handleChange} />
                </div>

                <div className="pd-right">

                    <div className="row clickable" onClick={(e) => {
                        if (e.target?.className?.includes("clickable")) {
                            setOpenSystemPrompt(!openSystemPrompt);
                        }
                    }}>
                        <div className="col-md-5 mb-4 clickable">
                            <h5>System Prompt</h5>
                            <CustomSelect name="systemPrompt" value={promptDetails?.systemPrompt} options={[{ label: "", value: "" }, ...systemPromptsOptions]} onChange={(e) => {
                                handleChange(e);
                                if (e.target.value === "new") {
                                    setOpenSystemPrompt(true);
                                }
                            }} />
                        </div>
                        <div className="col-md-12 mb-4 clickable">
                            <Collapse in={openSystemPrompt} timeout="auto" unmountOnExit>

                                <>
                                    {
                                        promptDetails?.systemPrompt === "new" &&
                                        <div className="col-md-8 mb-4">
                                            <h5>System Prompt Name</h5>
                                            <CustomInputV2
                                                required={true}
                                                value={promptDetails?.systemPrompt == "new" ? promptDetails?.newSystemPrompt?.name : selectedSystemPrompt?.name}
                                                type="text"
                                                onChange={(e) => {
                                                    handleSystemPromptChange(e, "name");
                                                }}
                                                name="name"
                                            />

                                        </div>
                                    }
                                    <div className="col-md-12 mb-4">
                                        <h5>System Prompts</h5>
                                        <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                                            handleSystemPromptChange({
                                                target: {
                                                    value: e.target.outerText,
                                                }
                                            }, "text");
                                        }}>
                                            {promptDetails?.systemPrompt == "new" ? promptDetails?.newSystemPrompt?.text : selectedSystemPrompt?.text}
                                        </pre>

                                        <CustomActionButton isPrimary={false} size="small" action={async () => {
                                            const toastID = toast.loading("Updating System Prompt...");

                                            const res = await props.UpdatePromptV2(promptDetails?.systemPrompt, {
                                                text: promptDetails?.updatedSystemPrompt?.text,
                                            }, true);

                                            if (res) {
                                                toast.dismiss(toastID);
                                            } else {
                                                toast.error("Failed to update system prompt", {
                                                    id: toastID,
                                                });
                                            }

                                            return res;

                                        }}>
                                            SAVE
                                        </CustomActionButton>
                                    </div>


                                </>
                            </Collapse>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 mb-4">
                            <h5>Name</h5>
                            <CustomInputV2
                                required={true}
                                value={promptDetails?.name}
                                type="text"
                                onChange={handleChange}
                                name="name"
                            />

                        </div>

                        <div className="col-md-4 mb-4">
                            <h5>Class</h5>
                            <CustomSelect name="type" options={[
                                { label: "Chat Completion", value: "chat-completion" },
                                { label: "Program Embeddings", value: "program-embeddings" },
                            ]} onChange={handleChange} />
                        </div>

                        <div className="col-md-12 mb-4">
                            <h5>Prompt</h5>
                            <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                                setTemporaryPrompt(e.target.outerText);
                            }}>
                                {promptDetails?.text}
                            </pre>
                        </div>

                        <div className="col-md-12">
                            <h5>Preview</h5>
                            <pre className="prompt-pre">
                                {
                                    promptPreview
                                }
                            </pre>
                        </div>

                        <div className="col-md-12">
                            <div id="prompt-actions">

                                <CustomActionButton isPrimary={false} size="small" disabled={isSubmitActive} action={async () => {

                                    const toastID = toast.loading("Updating Prompt...");
                                    const res = await props.UpdatePromptV2(promptDetails?.id, {
                                        name: promptDetails?.name,
                                        text: temporaryPrompt || promptDetails?.text,
                                        class: promptDetails?.class,
                                        type: promptDetails?.type,
                                        props: JSON.stringify(promptDetails?.properties),
                                        system_prompt: promptDetails?.systemPrompt ? promptDetails?.systemPrompt * 1 : null,
                                    });

                                    if (res) {
                                        toast.dismiss(toastID);
                                    } else {
                                        toast.error("Failed to update prompt", {
                                            id: toastID,
                                        });
                                    }

                                    return res;

                                }}>
                                    SAVE
                                </CustomActionButton>

                                <CustomActionButton size="small" disabled={isSubmitActive} action={async () => {

                                    const toastID = toast.loading("Testing Prompt...");
                                    const res = await props.TestPromptV2(promptPreview, {
                                        id: promptDetails?.id,
                                        systemPrompt: selectedSystemPrompt?.text || null,
                                    });

                                    if (res?.success) {
                                        toast.dismiss(toastID);
                                        setOpenSystemPrompt(false);
                                        setPromptOutput(res?.summary);

                                        delay(() => {
                                            outputRef.current?.scrollIntoView({ behavior: 'smooth' });
                                        }, promptOutput ? 0 : 200);

                                    } else {
                                        toast.error("Failed to test prompt", {
                                            id: toastID,
                                        });
                                    }


                                    return res?.success;
                                }}>
                                    TEST
                                </CustomActionButton>

                            </div>
                        </div>
                    </div>


                    {
                        promptOutput &&
                        <div className="row mt-4">
                            <div className="col-md-12 mb-3" ref={outputRef}>
                                <h5>Output</h5>
                                <pre className="prompt-pre">
                                    {promptOutput}
                                </pre>
                            </div>
                        </div>
                    }

                </div>

            </div>
        </>
    );
}


const mapStateToProps = (state) => ({
    Prompt: state.Prompt,
})

export default connect(mapStateToProps, {
    TestPromptV2,
    UpdatePromptV2,
})(NewPromptDetails);
